import React from 'react';
import PropTypes from 'prop-types';

const IconButton = ({icon, label, variant = "primary", onClick}) => {
    // TODO: Potentially add more discrete styling options based on button contents
    
    // const styles = {
    //     labelOnly: {
    //         minWidth: '120px',
    //     },
    // };

    return (
        <button
            type="button"
            className={`ddk-icon-button ${variant}`}
            onClick={onClick}
            // style={label && !icon ? styles.labelOnly : {}}
            aria-label={label}
        >
            {icon && icon}
            {label && <p>{label}</p>}
        </button>
    );
};

IconButton.propTypes = {
    /** The icon for the button. */
    icon: PropTypes.element,
    /** The label text for the button. */
    label: PropTypes.string,
    /**
     * The variant of the button.
     * Can be one of: 'primary', 'secondary', or 'tertiary'.
     */
    variant: PropTypes.oneOf(['primary', 'secondary', 'ghost']),
    /** The function to be called when the button is clicked. */
    onClick: PropTypes.func,
};

export default IconButton;
